<template>
  <v-app-bar tile color="primary" height="57">
    <v-app-bar-nav-icon @click="toggleDrawer()"></v-app-bar-nav-icon>

    <div class="clock">
      <v-icon color="white">mdi-clock</v-icon>
      {{ clock }}
    </div>

    <v-spacer />

    <v-toolbar-title class="text-end">
      <v-list-item>
        <v-list-item-title v-if="user.contragent">
          {{ user.contragent.shortname }}
        </v-list-item-title>

        <v-list-item-title v-if="isAdmin"> {{ $t('Администратор') }} </v-list-item-title>
      </v-list-item>
    </v-toolbar-title>

    <v-btn @click="this.logOut" icon>
      <v-icon>mdi-exit-to-app</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
export default {
  name: 'NavToolbar',
  props: {
    emitter: {
      required: true,
    },
    user: {
      required: true,
    },
    isAdmin: {
      type: Boolean,
      required: true,
    },
    logOut: {
      type: Function,
      required: true,
    },
    formatDate: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      clock: this.nowTimes(),
    };
  },
  methods: {
    toggleDrawer() {
      this.emitter.emit('toogleDrawer', {
        true: true,
        false: false,
      });
    },
    nowTimes() {
      return this.formatDate(new Date(), {
        hour: 'numeric',
        minute: 'numeric',
        timeZoneName: 'short',
      });
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.clock = this.nowTimes();
    }, 1000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>
